export default __webpack_public_path__ + "static/media/dark-twitter.d4c9bfd4.svg";